import { ConfirmWarrantController } from './confirmWarrant.controller';
import template from './confirmWarrant.html';

export const confirmWarrantComponent = {
  name: 'confirmWarrantComponent',
  restrict: 'E',
  template,
  controller: ConfirmWarrantController,
  controllerAs: 'vm',
  bindings: {
    ticket: '<',
    stateIndex: '<'
  }
};
